"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Page = function Page(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M23.25,4 L33,13.6 L33,32.8 C33,34.56 31.5375,36 29.75,36 L10.23375,36 C8.44625,36 7,34.56 7,32.8 L7.01625,7.2 C7.01625,5.44 8.4625,4 10.25,4 L23.25,4 Z M26.5,29.6 L26.5,26.4 L13.5,26.4 L13.5,29.6 L26.5,29.6 Z M26.5,23.2 L26.5,20 L13.5,20 L13.5,23.2 L26.5,23.2 Z M21.625,15.2 L30.5625,15.2 L21.625,6.4 L21.625,15.2 Z"
      });
    }
  }));
};
Page.defaultProps = {
  color: null
};
var _default = exports["default"] = Page;
var name = exports.name = 'Page';
var availableProps = exports.availableProps = ['color'];